<template>
  <vk-dialog
    :visible.sync="visible"
    @close="closeDialog"
    title="新生政策说明"
    class="policy-dialog-component"
  >
    <div
      class="policy-dialog-content"
      v-if="visible"
    >
      <template v-if="listKey.includes('0')">
        <b>1.免费试学期：</b>
        <template v-if="!versions.includes('v6.1')">
          <p>
            自您开始使用任一课程服务之日起30天内（但不得超出退费有效期），并且在退费前您被扣除的主修课课时数量小于或等于12节（含缺席课时）的情形下，您可以申请全额退费。
          </p>
          <p>
            课程服务：VIPKID为您提供的主修课、精品公开课及能够消耗主修课或精品公开课课时的其他课程。
          </p>
          <p>*退费有效期及其他免费试学期相关规定，详见《课程服务协议》。</p>
        </template>
        <template v-else>
          <p>
            自您开始使用任一课程服务之日起30天内，且您已使用的课段数不超过4个（一个课段中外教课程的2个课时被扣除时，包含缺席，即视为已使用了该课段）的情形下，您可以申请全额退费。
          </p>
          <p>
            课程服务：VIPKID为您提供的全项进阶课及能够消耗全项进阶课课时的其他课程。
          </p>
        </template>
        <br />
      </template>

      <template v-if="listKey.includes('1')">
        <b>2.课程有效期：</b>
        <template v-if="!versions.includes('v6.1')">
          <p>
            若课程包为3个单元，则有效期为180天；
          </p>
          <p>
            若课程包为6个单元，则有效期为360天；
          </p>
          <p>
            若课程包为12个单元，则有效期为720天；
          </p>
          <p>
            若课程包为24个单元，则有效期为1440天；
          </p>
          <p>
            若课程包为36个单元，则有效期为2160天。
          </p>
          <p>
            若您自支付完成课程费用之日起30天内开课，则课程有效期自首次开课之日开始计算；
          </p>
          <p>
            若您自支付完成课程费用之日起30天内未开课，则课程有效期自支付完成后第31个自然日起计算。
          </p>
          <p>
            *开课定义及其他课程有效期相关规定，详见《课程服务协议》。
          </p>
        </template>
        <template v-else>
          <p>
            40周课课程包有效期为360天。
          </p>
          <p>
            若您自支付完成课程费用之日起30天内开课，则课程有效期自首次开课之日开始计算；
          </p>
          <p>
            若您自支付完成课程费用之日起30天内未开课，则课程有效期自支付完成后第31个自然日起计算。
          </p>
        </template>
        <br />
      </template>

      <template v-if="listKey.includes('2')">
        <b>3.退费有效期：</b>
        <p>
          若您自支付完成课程费用之日起30天内开课，则您自首次开课之日起180天内可申请退费，超过前述期限不得要求退费；
        </p>
        <p>
          若您自支付完成课程费用之日起30天内未开课，则您自支付完成后第31个自然日起180天内可申请退费，超过前述期限不得要求退费。
        </p>
        <p>
          *开课定义及其他退费有效期相关规定，详见《课程服务协议》。
        </p>
        <br />
      </template>

      <template v-if="listKey.includes('3')">
        <b>4.休学政策：</b>
        <p>
          如果您在课程有效期内的特定期间无法使用课程服务，您可申请休学，每次休学最长不得超过30个自然日：
        </p>
        <p>
          若课程包为3个单元，有一次休学机会；
        </p>
        <p>
          若课程包为6个单元，有二次休学机会；
        </p>
        <p>
          若课程包为12个单元，有三次休学机会；
        </p>
        <p>
          若课程包为24个单元，有四次休学机会；
        </p>
        <p>
          休学期间，课程有效期中止计算，但退费有效期不中止计算。
        </p>
        <p>
          *词语定义以及其他休学相关规定，详见《课程服务协议》。
        </p>
      </template>
    </div>
  </vk-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    versions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    listKey() {
      return this.list.reduce((total, o) => {
        return total + o.key
      }, '')
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="less" scoped>
.policy-dialog-component {
  /deep/.vk-dialog {
    color: #555;
    line-height: 18px;
    font-size: 14px;
    .dialog-content {
      padding-right: 0;
      margin-bottom: 10px;
    }
    .policy-dialog-content {
      padding-right: 20px;
      max-height: 400px;
      overflow-y: auto;
      overflow-x: hidden;
    }
    * {
      color: #555;
    }
    p {
      margin-top: 8px;
    }
  }
}
</style>
